import axiosInstance from "./axiosInstance";

export const register = async (data) => {
  return await axiosInstance.post("/user/register", data);
};


export const signin = async (data) => {
    return await axiosInstance.post("/user/login", data, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const changePassword = async (data) => {
  return await axiosInstance.post("/user/change-password", data);
};
